'use client';

import { useActivityStore } from '@/service/state/Activity/useActivityStore';
import { ArrowRightIcon } from '../Icons/ArrowRightIcon';
import { useEffect } from 'react';
import { useParams } from 'next/navigation';
import { usePartnerStore } from '@/service/state/Partner/usePartnerStore';
import { scrollToId } from '@/service/utils/scrollToId';
import { cn } from '@/service/utils/cn';
import { numberWithCommaFormatter } from '@/service/utils/numberWithCommaFormatter';

type TRatingLinkProps = {
    count: string;
    activityId: string;
    showReviews?: boolean;
};

export const RatingLink = ({ count, activityId, showReviews }: TRatingLinkProps) => {
    const { partner_slug } = useParams();

    const { isLightframePage } = usePartnerStore();
    const setOpenReviews = useActivityStore((state) => state.setOpenReviews);

    const scrollToReviews = () => {
        if (!showReviews) {
            return;
        }

        if (isLightframePage) {
            scrollToId('reviews', 'start');
        } else {
            const el = document.querySelector('#reviews');
            if (el) {
                const y = el.getBoundingClientRect().top + window.scrollY;
                window.scrollTo({ top: y - 75, behavior: 'smooth' });
            }
        }
    };

    useEffect(() => {
        setOpenReviews(activityId, partner_slug.toString(), count);
    }, [setOpenReviews, activityId, partner_slug, count]);

    if (!+count) {
        return <></>;
    }

    const reviewsCountWithComma = numberWithCommaFormatter(+count);

    return (
        <span
            onClick={scrollToReviews}
            className={cn(
                'tx-large-regular ml-2 flex items-baseline text-state-info',
                showReviews ? 'cursor-pointer underline' : ''
            )}
            data-test-id="rating-link"
        >
            {reviewsCountWithComma} ratings{' '}
            {showReviews && <ArrowRightIcon className=" ml-1 [&>*]:fill-state-info" />}
        </span>
    );
};
